export function DropdownBox(props) {
    return (
        <div className="dropdown-box w-40">
            <div className="dropdown-box__content box dark:bg-dark-1 p-2"> 
                {props.children}
            </div>
        </div>
    )
    
}